import { CurrentMember, PendingMember } from "./types";

type OrgCurrentMemberRule = (
    memberToTakeActionOn: CurrentMember,
    loggedInUser: { role: "admin" | "owner" | "member"; email: string }
) => boolean;

type OrgPendingMemberRule = (
    memberToTakeActionOn: PendingMember,
    loggedInUser: { role: "admin" | "owner" | "member"; email: string }
) => boolean;

export const canDeleteMember: OrgCurrentMemberRule = (memberToTakeActionOn, loggedInUser) =>
    memberToTakeActionOn.role !== "owner" &&
    loggedInUser.role !== "member" &&
    loggedInUser.email !== memberToTakeActionOn.email;
export const canUpdateMemberRole: OrgCurrentMemberRule = (memberToTakeActionOn, loggedInUser) =>
    memberToTakeActionOn.role !== "owner" &&
    loggedInUser.role !== "member" &&
    loggedInUser.email !== memberToTakeActionOn.email;
export const canRenameOrganization = (role: "admin" | "owner" | "member") => role === "owner";

export const canCopyInviteLink: OrgPendingMemberRule = (_, loggedInUser) => loggedInUser.role !== "member";
export const canRevokeInvite: OrgPendingMemberRule = (_, loggedInUser) => loggedInUser.role !== "member";
export const canResendInvite: OrgPendingMemberRule = (_, loggedInUser) => loggedInUser.role !== "member";
export const canInviteMember = (loggedInUser: { role: "admin" | "owner" | "member"; email: string }) =>
    loggedInUser.role !== "member";

export function validateOrgName(input: string) {
    const result: { success: true } | { success: false; error: string } = { success: true };
    const regexStartWithLetter = /^[A-Za-z]/;
    const regexAllowedChars = /^[A-Za-z0-9_-]*$/;

    if (input.length < 1 || input.length > 256) {
        return { success: false, error: "Name must be between 1 and 256 characters long" };
    }
    if (!regexStartWithLetter.test(input)) {
        return { success: false, error: "Name must start with a letter" };
    }
    if (!regexAllowedChars.test(input)) {
        return { success: false, error: "Name can only contain letters, digits, underscores, and hyphens" };
    }

    return result;
}

export function validatePasswordInput(input: string) {
    const shouldContainADigitRegex = /.*\d.*/;
    const result: { success: true } | { success: false; error: string } = { success: true };

    if (input.length < 8) {
        return { success: false, error: "Password must contain at least 8 characters" };
    }
    if (!shouldContainADigitRegex.test(input)) {
        return { success: false, error: "Password must contain at least one number" };
    }
    return result;
}

const ADMIN_PERMISSIONS =
    "An admin can access and modify the app management, billing page and organizations member list.";

const MEMBER_PERMISSIONS =
    "A member can only view organization details (but not modify the member list), and can access and modify the app management page.";

export const getRoleDetails = (role: "admin" | "member") => {
    return role === "member" ? MEMBER_PERMISSIONS : ADMIN_PERMISSIONS;
};

export const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
